module.exports = __webpack_public_path__ + "static/img/xcx_icon.17499ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xcx_icon.png
// module id = vxRr
// module chunks = 8